import React, { useState } from "react";
import { Button, Modal, Flex, Typography, Row } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./styles.scss";

const NeedHelp = ({ style }) => {
	const [isModalVisible, setIsModalVisible] = useState(false);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	return (
		<Flex flex={1} align="center">
			<Button
				type="primary-filled need-help-btn"
				size="small"
				onClick={showModal}
				style={{
					background: "#1777FF",
					color: "#fff",
					border: "none",
					flex: 1,
					maxWidth: 120,
					height: 24,
					fontSize: 12,
					...style,
				}}
			>
				<InfoCircleOutlined />
				Need Help
			</Button>
			<Modal
				maskClosable={false}
				className="need-help"
				footer={null}
				open={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
			>
				<Typography.Title style={{ textAlign: "center" }} level={3}>
					First Time Streaming?
				</Typography.Title>
				<Typography.Paragraph style={{ fontSize: 12 }}>
					Begin your streaming journey by following our guide on how to go live.
				</Typography.Paragraph>
				<Row className="label">Step 1 - Download OBS</Row>
				<Typography.Paragraph style={{ fontSize: 12 }}>
					For free live streaming software, we highly recommended Open Broadcaster Software (OBS) which can be
					downloaded for free from
					<Link target="_blank" to="https://obsproject.com/">
						{" "}
						<i>https://obsproject.com/</i>
					</Link>
				</Typography.Paragraph>
				<Row className="label">Step 2 - Find Stream Settings</Row>
				<Typography.Paragraph style={{ fontSize: 12 }}>
					1. Click <strong style={{ fontWeight: 700 }}>“Settings”</strong> on the bottom right hand corner.
				</Typography.Paragraph>
				<Typography.Text style={{ fontSize: 12 }}>
					2. From settings window click on <strong style={{ fontWeight: 700 }}>“Stream”</strong> located on the sidebar.
				</Typography.Text>
			</Modal>
		</Flex>
	);
};

export default NeedHelp;

